import { OptionsType } from '@/types/antd';

/** LLMModel 调用后台的大模型枚举 */
enum LLMModel {
  default = 'default',
  deepseek = 'deepseek',
}

/** LLMOutPutCharType 大模型输出到字符类型（推理过程 / 正文） */
enum LLMOutPutCharType {
  reasoningContent = 'reasoning_content',
  content = 'content',
  cite = 'cite',
  authContent = 'auth_content',
}

/** LLM_MODAL_OTIONS 大模型选择器 options */
const LLM_MODAL_OTIONS: OptionsType = [
  {
    value: LLMModel.default,
    label: 'default',
  },
  {
    value: LLMModel.deepseek,
    label: 'deepseek',
  },
];

export { LLM_MODAL_OTIONS, LLMModel, LLMOutPutCharType };
